import React from 'react';
import { useTranslation } from 'react-i18next';
import TicketCardContainer from './ticket';
import {Button} from '../ui/card/card';
import NeoInfo from '../neoInfo';
import { APIAction } from '../order-menu/api-action/api-action';

import './ticket-confirm.css';

export default function TicketView({ config, onSubmit }) {
	const { t } = useTranslation();
	const ticket_view = config['ticket-view'];
	const { attendee, actions, config: configTicket } = ticket_view; // eslint-disable-line
	const successMessage = {info: t('widget.step-confirm.confirm-message')};

	// TicketView can have severals back actions, we need to dynamically find the right one
	const typeBackAction = React.useMemo(() => {
		if (actions?.length > 0){
			const backAction = actions.find(
				action => action.type === 'OrderMenu' || action.type === 'HomeEventStep'
			)
			if (backAction)
				return backAction.type
		}
		return ''
	}, [actions])

	return (
		<div className='wz-confirm-container'>
			<div className='wz-confirm-title'><strong>{t('widget.step-confirm.title')}</strong></div>
			<NeoInfo config={ successMessage } variant='success'/>
			<TicketCardContainer attendee={attendee} config={configTicket}/>
			<div className="wz-confirm-footer">
				<APIAction name={typeBackAction} actions={ actions }>
					<Button
						className='wz-cta-back'
						onClick={() => onSubmit({
							data: {
								action: typeBackAction,
							}
						})}
					>
						{t('widget.ticket.back-to-order')}
					</Button>
				</APIAction>
				<APIAction name={'DownloadTicketStep'} actions={ actions }>
					<Button
						className='wz-cta-download'
						onClick={() => onSubmit({data: {action: 'DownloadTicketStep', payload: { attendee_id: attendee.id }}})}
					>
						{t('widget.step-confirm.cta-download')}
					</Button>
				</APIAction>
			</div>
		</div>
	)
}
